export default __webpack_public_path__ + "13c45bc222408f22a47bb5d166cb7c0a.png";